export default __webpack_public_path__ + "static/media/time-rate-editor-button.9bf5a941.png";